/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 代理案件紀錄查詢參數
 */
export interface SubstituteCaseSearchViewModel { 
    /**
     * 系統ID
     */
    systemId?: number;
    /**
     * 系統功能ID
     */
    systemFunctionId?: number;
    /**
     * 案件來源單位
     */
    applyDepartmentId?: number;
    /**
     * 被代理人
     */
    principalSubstitute?: string;
    /**
     * 代理人
     */
    substitute?: string;
    /**
     * 代理期間起日
     */
    substituteFrom?: Date;
    /**
     * 代理期間迄日
     */
    substituteTo?: Date;
}